<template>
    <div class="product-page">
        <img src="../assets/images/1.png" alt="" style="display: none;">
        <div class="headerBg"></div>
        <div class="product-box">
            <ul>
                <li v-for="item in list" 
                    @click="toDetail(item)"
                    :key="item.itemName">
                    <img :src="item.img" alt="">
                    <p>{{item.itemName}}</p>
                    <span>{{item.name}}</span>
                </li>
            </ul>
        </div>
        <!-- <div class="copyright"> 好前程信息技术（深圳）有限公司 <a href="">&nbsp;&nbsp;粤ICP备2023019808号-4</a></div> -->
        <van-tabbar v-model="active" active-color="#fe2c55">
            <van-tabbar-item icon="wap-home-o">首页</van-tabbar-item>
            <van-tabbar-item icon="user-o">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
import {bussData} from '../bussData/index'
import {getProducts} from '../api/api'
export default {
    data() {
        return {
            list: [],
            active: 0
        }
    },
    created() {
        this.getProductList()
        document.title = '特惠充值'
    },
    methods: {
        getProductList() {
            this.list = Object.keys(bussData).map(key => {
                const {name, itemName, iconImg: img, type, ...props} = bussData[key]
                const item = {
                    name, 
                    itemName, 
                    img, 
                    type,
                    ...props
                }
                return item
            })

            console.log(this.list);
        },
        toDetail(item) {
            console.log(item);
            this.$router.push({ 
                name: 'productDetail', 
                params: { 
                    type: item.type, // 产品类型
                    orderType: item.orderType // 产品编号
                } 
            })
        },

    }
}
</script>
<style lang="less" scoped>

.product-page {
    .copyright {
        font-size: 10px;
        color: #999;
        text-align: center;
        a {
            color: #999;
        }
    }
}
.headerBg {
    width: 100%;
    height: 220px;
    background: linear-gradient(181deg, #c0d6ff, transparent);
}
.product-box {
    padding: 10px;
    margin-top: -200px;
    
    ul {
        border-radius: 6px 6px;
        margin-top: 15px;
        display: flex;
        flex-wrap: wrap;
        padding: 15px;
        align-items: flex-start;
        gap: 15px 0;
        background: #ffffff75;
        li {
            width: 25%;
            text-align: center;
            img {
                width: 60px;
                height: 60px;
                object-fit: fill;
                 object-position: center center;
                //  border-radius: 50%;
            }
            p {
                font-weight: 600;
                margin: 5px 0 3px 0;
            }
            span {
                font-size: 12px;
                color: #888;
            }
        }
    }
}
</style>